// العربية (User Panel)
const ar = {
  common: {
    loading: "جارٍ التحميل...",
    back: "رجوع",
    cancel: "إلغاء",
    confirm: "تأكيد",
    save: "حفظ",
    saved: "تم الحفظ",
    submit: "إرسال",
    submitting: "جارٍ الإرسال...",
    saving: "جارٍ الحفظ...",
    ok: "موافق",
    error: "خطأ",
    success: "نجاح",
    pending: "قيد الانتظار",
    approved: "تمت الموافقة",
    rejected: "مرفوض",
    completed: "مكتمل",
    all: "الكل",
    failed: "فشل",
    select_language: "اختر اللغة",
    language: "اللغة",
    unable_server: "تعذر الاتصال بالخادم. يرجى المحاولة مرة أخرى.",
    fill_all: "يرجى ملء جميع الحقول",
    hint_disabled: "الودائع والسحوبات معطلة حاليًا",
    account_disabled:
      " المعاملات معطلة لحسابك. يرجى الاتصال بالدعم.",
  },

  navbar: {
    home: "الرئيسية",
    history: "السجل",
    starting: "البدء",
    services: "الخدمات",
    my_profile: "ملفي الشخصي",
  },

  page: {
    home: "الرئيسية",
    history: "السجل",
    services: "الخدمات",
    deposit: "الإيداع",
    withdraw: "السحب",
    widthraw_page: "السحب",
    withdrawal_account: "حساب السحب",
    deposit_history: "سجل الإيداعات",
    withdraw_history: "سجل السحوبات",
    starting: "البدء",
    my_profile: "ملفي الشخصي",
    security_pin: "رمز الأمان PIN",
    login_password: "كلمة مرور الدخول",
    invite_friends: "دعوة الأصدقاء",
    about_us: "من نحن",
    faq: "الأسئلة الشائعة",
    vip_rules: "قواعد VIP",
    invitation_rules: "قواعد الدعوة",
    about_us_details: "من نحن",
  },

  home: {
    welcome: "مرحبًا بك",
    vip_level: "مستويات VIP",
    popular: "الأكثر شيوعًا",
    deposit: "الإيداع",
    withdrawal: "السحب",
    about_us: "من نحن",
    invite_friends: "دعوة الأصدقاء",
  },

  deposit: {
    title: "الإيداع",
    amount_label: "مبلغ الإيداع",
    total_balance: "الرصيد الإجمالي",
    bank_card: "البطاقة المصرفية",
    quick_selection: "اختيار سريع",
    err_amount: "يرجى إدخال مبلغ إيداع صالح",
    range_hint: "النطاق المسموح لـ {vip}: {min} - {max}",
    err_below: "لا يمكن أن يكون مبلغ الإيداع أقل من {min}",
    err_above: "لا يمكن أن يتجاوز مبلغ الإيداع {max}",
    err_loading_card: "يرجى الانتظار، جارٍ تحميل بطاقتك المصرفية",
    err_add_card:
      "يرجى إضافة بطاقتك المصرفية أولًا في ملفي الشخصي ← حساب السحب",
    info_title: "معلومات البطاقة المصرفية",
    info_hint:
      "تُؤخذ تفاصيل البطاقة المصرفية تلقائيًا من حساب السحب (ملفي الشخصي).",
    bank_name: "اسم البنك",
    card_number: "رقم البطاقة",
    account_holder: "اسم صاحب الحساب",
    ph_bank_name: "أدخل اسم البنك",
    ph_card_number: "أدخل رقم البطاقة",
    ph_account_holder: "أدخل الاسم على الحساب المصرفي",
    waiting_title: "في انتظار الموافقة....",
    waiting_text:
      "تم إرسال طلب إعادة التعبئة. يرجى الانتظار حتى يؤكد المسؤول.",
  },

  withdraw: {
    title: "السحب",
    amount_label: "مبلغ السحب",
    total_balance: "الرصيد الإجمالي",
    method_title: "طريقة السحب",
    method_hint:
      "تأتي هذه التفاصيل من حساب السحب (ملفي الشخصي) ولا يمكن تعديلها هنا.",
    bank_card: "البطاقة المصرفية",
    usdt: "USDT",
    wise: "Wise",
    revolut: "Revolut",
    bank_name: "اسم البنك",
    bank_account: "الحساب المصرفي/USDT",
    full_name: "الاسم الكامل",
    usdt_address: "عنوان USDT",
    usdt_protocol: "بروتوكول USDT",
    wise_email: "البريد الإلكتروني لحساب Wise",
    wallet_address: "عنوان المحفظة",
    security_pin: "رمز الأمان PIN",
    time_title: "وقت السحب",
    time_text:
      "يُسمح بالسحب فقط بين 01:00:00 و17:00:00. يرجى المحاولة مرة أخرى خلال هذا الوقت.",
    success: "تم إرسال طلب السحب، في انتظار الموافقة",
    err_amount: "يرجى إدخال مبلغ سحب صالح",
    err_pin: "يرجى إدخال رمز الأمان PIN الخاص بك",
    err_loading: "يرجى الانتظار، جارٍ تحميل حساب السحب",
    err_details:
      "يرجى إضافة بيانات ({method}) أولًا في ملفي الشخصي ← حساب السحب",
    err_bank: "يرجى ملء اسم البنك ورقم الحساب والاسم الكامل",
    err_usdt: "يرجى ملء عنوان USDT والاسم الكامل",
    err_wise: "يرجى ملء البريد الإلكتروني لحساب Wise والاسم الكامل",
    err_revolut: "يرجى ملء عنوان المحفظة والاسم الكامل",
    limit_title: "خطأ في الطلب",
    err_below: "لا يمكن أن يكون مبلغ السحب أقل من {min}",
    err_above: "لا يمكن أن يتجاوز مبلغ السحب {max}",
    err_daily: "تم الوصول إلى الحد اليومي للسحب. يُسمح بـ {count} سحب في اليوم.",
  },

  waccount: {
    title: "حساب السحب",
    hint:
      "تُستخدم هذه التفاصيل تلقائيًا في الإيداع والسحب. بعد إرسالها، تُحفظ في قائمة البطاقات المصرفية الخاصة بالمسؤول.",
    usdt_number: "رقم USDT",
    confirm_text: "هل أنت متأكد من حفظ بيانات حساب السحب هذه؟",
    saved_success: "تم حفظ حساب السحب بنجاح",
  },

  history: {
    pending: "قيد الانتظار",
    completed: "مكتمل",
    no_records: "لم يتم العثور على سجلات",
    total_amount: "المبلغ الإجمالي:",
    profit: "الربح:",
    volume: "حجم المعاملات:",
    order_submitted: "تم إرسال الطلب بنجاح",
  },

  start: {
    current: "الحالي",
    profit: "الربح:",
    application: "الطلبات:",
    welcome: "مرحبًا! أهلًا بك",
    commission_details: "تفاصيل العمولة",
    today_profit: "ربح اليوم",
    account_balance: "رصيد الحساب",
    starting: "البدء",
    important_notice: "تنبيه مهم",
    working_hours: "• ساعات العمل: 09:00:00 - 23:58:59",
    contact_line:
      "• لأي استفسار، يرجى التواصل مع خدمة العملاء عبر الإنترنت!",
    processing: "جارٍ المعالجة...",
    start: "ابدأ",
    order_product: "منتج الطلب",
    rating: "التقييم:",
    price: "السعر:",
    commission: "العمولة:",
    order_done: "تم إنجاز الطلب! أُضيف الربح {amount} إلى رصيدك.",
    unable_server: "تعذر الاتصال بالخادم",
  },

  sv: {
    online: "عبر الإنترنت",
    customer: "خدمة العملاء",
    services: "الخدمات",
  },

  mp: {
    invitation_code: "رمز الدعوة",
    credit_reputation: "السمعة الائتمانية",
    today_profit: "ربح اليوم",
    account_balance: "رصيد الحساب",
    orders_count: "عدد الطلبات",
    invite_friends: "دعوة الأصدقاء",
    invite_subtitle: "ادعُ أصدقاءك واحصل على المكافآت",
    logout: "تسجيل الخروج",
    logout_confirm: "هل أنت متأكد من أنك تريد تسجيل الخروج؟",
    footer: "حقوق النشر © 2023 Nativz. جميع الحقوق محفوظة.",
    user: "المستخدم",
  },

  lp: {
    old_password: "كلمة المرور القديمة",
    new_password: "كلمة المرور الجديدة",
    confirm_password: "تأكيد كلمة المرور الجديدة",
    note:
      "يرجى الاتصال بخدمة العملاء إذا نسيت كلمة مرور الدخول القديمة.",
    err_min: "يجب أن تتكون كلمة المرور الجديدة من 6 أحرف على الأقل",
    err_mismatch: "كلمة المرور الجديدة وتأكيدها غير متطابقين",
  },

  sp: {
    old_pin: "رمز PIN القديم",
    new_pin: "رمز PIN الجديد",
    confirm_pin: "تأكيد رمز PIN الجديد",
    note:
      "يرجى الاتصال بخدمة العملاء إذا نسيت رمز الأمان PIN القديم.",
    err_min: "يجب أن يتكون رمز PIN الجديد من 6 أحرف على الأقل",
    err_mismatch: "رمز PIN الجديد وتأكيده غير متطابقين",
  },

  dh: {
    title: "سجل الإيداعات",
    empty: "لا يوجد سجل إيداعات بعد",
  },

  wh: {
    title: "سجل السحوبات",
    empty: "لا يوجد سجل سحوبات بعد",
  },

  ifr: {
    title: "دعوة الأصدقاء",
    link_copied: "تم نسخ الرابط",
    copy_prompt: "انسخ هذا الرابط:",
  },

  faq: {
    title: "الأسئلة الشائعة",
    important_reminder: "تذكير مهم",
    reminder_text:
      "يُمنع منعًا صارمًا أي أنشطة غسل أموال ضار. عند اكتشافها، ستجمّد المنصة الحسابات التالية وتتخذ الإجراءات القانونية المناسبة.",
    deposit_heading: "الإيداع",
    deposit_text:
      "يجب إرسال كل إيداع إلى خدمة العملاء لمساعدةك في إعادة تعبئة حسابك. بعد تحويل الأموال إلى الحساب الذي يوفره فريق دعم المنصة، يرجى تقديم إثبات التحويل الناجح. لضمان استلام إيداعك فورًا، تأكد من تطابق اسم المستلم والمبلغ المحول. إذا واجهت أي مشكلة لم تُحل أثناء عملية الإيداع، يرجى الاتصال بخدمة العملاء. نظرًا لكمية المعلومات الكبيرة، يرجى مراجعة التفاصيل بعناية قبل إتمام المعاملة. قد تغير المنصة معلومات حسابك من وقت لآخر. إذا واجهت أي مشكلة لم تُحل أثناء عملية الإيداع، يرجى الاتصال بخدمة العملاء. لأي استفسار، يرجى الاتصال بخدمة العملاء عبر الإنترنت في المنصة.",
    withdraw_heading: "سحب الأموال",
    withdraw_text:
      "قبل سحب أموالك، يرجى ربط عنوان السحب بالمنصة. لسحب الأموال، انتقل إلى شاشة \"سحب الأموال\" في الصفحة الرئيسية، واضغط زر \"السحب\"، ثم أدخل المبلغ الذي ترغب في سحبه وكلمة مرور السحب.",
    note: "(ملاحظة: يرجى الاتصال بخدمة العملاء لدينا للمساعدة.)",
  },

  ir: {
    title: "قواعد الدعوة",
    p1: "يمكن لأعضاء المنصة استخدام رموز الإحالة لدعوة الآخرين للانضمام إلى فريقك. ستحصل على عمولة بنسبة مئوية من أرباح أعضاء فريقك. ستعاد الأرباح إليك مباشرة عبر حسابك في المنصة أو في تقارير فريقك.",
    notice: "تنبيه:",
    p2: "يتلقى جميع الوكلاء وأعضاء شبكتهم السفلى نسبة محددة من الدخل والمكافآت من المنصة. يبلغ الدخل 30% من العمولات المكتسبة من المشاركين في شبكتهم السفلى. لا تقدم المنصة دعمًا لتطوير أعضاء الفريق السفلي، ولا تؤثر سلبًا على دخل الوكلاء ومكافآتهم.",
  },

  vr: {
    title: "قواعد VIP",
    p1: "يتكون VIP 1 من 30 طلبًا في الدورة. لإنجاز هذه الطلبات، يلزم رصيد حد أدنى قدره 25 USDT. يبلغ حد السحب لهذا المستوى من 100 USDT إلى 5,000 USDT كحد أقصى.",
    p2: "يتكون VIP 2 من 40 طلبًا في الدورة. للترقية إلى VIP 2، يلزم إيداع حد أدنى قدره 1,500 USDT. يبلغ حد السحب لهذا المستوى من 100 USDT إلى 10,000 USDT كحد أقصى.",
    p3: "يتكون VIP 3 من 50 طلبًا في الدورة. لفتح VIP 3، يلزم إيداع حد أدنى قدره 5,000 USDT. يبلغ حد السحب لهذا المستوى من 100 USDT إلى 50,000 USDT كحد أقصى.",
    p4: "يتكون VIP 4 من 60 طلبًا في الدورة. لفتح VIP 4، يلزم إيداع حد أدنى قدره 10,000 USDT. يبلغ حد السحب لهذا المستوى من 100 USDT إلى 1,000,000 USDT كحد أقصى. كما يحصل مستخدمو VIP 4 على عمولة إضافية قدرها 10% مقارنة بمستويات VIP الأقل.",
  },

  ad: {
    title: "من نحن",
    intro:
      "الشروط والأحكام الخاصة بالتسجيل كشريك أو متجر أو منصة أو موظف في Oneforma.",
    h_agreement: "اتفاقك",
    p1: '1. قبل استخدام أو عرض أو إنشاء حساب على منصة oneforma.com ("OneForma")، يرجى قراءة هذه الشروط والأحكام ("الشروط") بعناية. يخضع وصولك إلى OneForma واستخدامك لها لقبولك والالتزام بهذه الشروط والأحكام وCENTIFIC GLOBAL SOLUTIONS, Inc. ("CENTIFIC"). تنطبق هذه الشروط على جميع الزوار والمستخدمين والمشاهدين والآخرين الذين يصلون إلى OneForma أو يستخدمونها.',
    p2: '2. بتقديم أي خدمات أو تنفيذ أي مشاريع مخصصة على منصة Oneforma، تقرّ بأنك ("أنت" أو شريكك أو المتجر الشريك أو المنصة الشريكة والموظفين) قد عقدت اتفاقية خدمات مع CENTIFIC، والتي تتضمن الشروط والأحكام والبنود المطبقة بموجب القانون الساري، ووصف الخدمات أو أمر العمل، ووثائق مكتوبة أخرى تمت الموافقة عليها بشكل متبادل بين الطرفين ("الاتفاقية"). في حال وجود أي تعارض بين هذه الشروط والأحكام وأي اتفاقيات سابقة عقدتها بشأن هذا الموضوع، تسود هذه الشروط والأحكام.',
    p3: "3. بالتسجيل في OneForma أو استخدامها، توافق على الالتزام بهذه الاتفاقية. إذا كنت لا توافق على أي جزء أو على كامل هذه الاتفاقية، فلا يجوز لك التسجيل في OneForma.",
    h_relationships: "العلاقات بين جميع الأطراف",
    p4: "1.1. دور CENTIFIC: تُعد OneForma منصة تابعة لـ CENTIFIC، ومقرها 14980 NE 31st Way, Suite 100, Redmond, WA 98052. البريد الإلكتروني للتواصل: omegaguttakdl53@gmail.com",
    p5: 'توفر CENTIFIC منصة OneForma، مما يتيح لمستخدميها اتخاذ القرار واختيار الدخول في اتفاقيات. تقدم خدماتك لأطراف ثالثة أو لـ CENTIFIC ("مالك المشروع") الذين يكلفون العمل أو المشاريع على OneForma. أي خدمات أو أعمال تؤديها بموجب هذه الاتفاقية تكون لصالح مالك المشروع ولا تشكل جزءًا من العمليات التجارية العادية لـ CENTIFIC ("الخدمات").',
    h_deliverables: "1.2. المخرجات",
    p6: "لن تقدم لك CENTIFIC موقع عمل دائمًا ولن تتطلب منك أداء خدماتك في أي موقع مصمم خصيصًا. يجب عليك تحديد موقع العمل لكل مشروع وفق تقديرك الشخصي. بالنسبة لأي مشروع يتطلب العمل في الموقع، تحتفظ بالحق الكامل في عدم الشروع في مثل هذا المشروع.",
    h_statement: "1.3. تصريحك",
    p7: "بقراءة هذه الاتفاقية، تقرّ وتضمن لـ CENTIFIC أنك:",
    p8: "عادةً ما تمارس تجارة أو نشاطًا تجاريًا مستقلاً من نفس طبيعة الخدمات المقدمة بموجب هذه الاتفاقية. يجب أن تمتلك أنت أو أفراد فريق المشروع المهارات والخبرة والمؤهلات اللازمة لأداء الخدمات؛",
    p9: "يجب عليك أو لفريق المشروع تقديم الخدمات بطريقة احترافية ومهارة، ملتزمين بأفضل المعايير الصناعية للخدمات المماثلة، وبمستوفي متطلبات الحكومة المركزية ومالك المشروع. يجب عليك أو لفريق المشروع تخصيص موارد كافية لضمان تقديم خدمات في الوقت المحدد وموثوق.",
    p10: "يجب عليك أو لموظفي المشروع أداء الخدمات وفقًا لجميع القوانين واللوائح الفيدرالية والدولة وغيرها من القوانين الوطنية والمحلية المعمول بها، بما في ذلك الاحتفاظ بجميع التراخيص والأذونات والتسجيلات اللازمة لأداء الخدمات؛",
    p11: "يحق لك عقد هذه الاتفاقية أو توظيف موظفي المشروع أو منح الحقوق وفقًا للبنود ذات الصلة لهذه الاتفاقية، وتحمل المسؤولية الكاملة عن أداء جميع الخدمات بموجب هذه الاتفاقية؛",
    p12: "ستوفر، على حسابك، جميع المواد والمعدات والمستلزمات والموارد الأخرى اللازمة لأداء الخدمات، بما في ذلك أي مصاريف سفر أو تكاليف أخرى يتكبدها أنت أو موظفو مشروعك أثناء أداء الخدمات؛ ولن يكون لك أو لموظفي مشروعك أي حق في إجازة أو تأمين طبي أو تأمين على الحياة جماعي أو تأمين ضد الإعاقة أو المشاركة في الأرباح أو مزايا التقاعد أو أي مزايا إضافية أخرى أو خطط رفاهية تقدمها CENTIFIC لموظفيها، ولن تكون CENTIFIC مسؤولة عن خصم أو دفع أي ضريبة دخل أو أروش أو ضمان اجتماعي أو ضرائب فيدرالية أو حكومية أو محلية أخرى، أو دفع أي أقساط تأمين (بما في ذلك أقساط تأمين البطالة أو الإعاقة) أو الحصول على تأمين تعويض العمال نيابة عنك، إلا إذا طالب القانون المعمول به بذلك؛ وستكون مسؤولًا وتعوض CENTIFIC عن جميع تلك الضرائب أو المساهمات، بما في ذلك الغرامات والفوائد، وتتخلى صراحةً عن أي حق في المطالبة بتعويض من CENTIFIC عن أي أذى قد تصاب به أنت (وموظفيك والمقاولين) أثناء أداء الخدمات بموجب هذه الاتفاقية.",
    h_term: "2. المدة والإنهاء",
    p13: "2.1. تصبح هذه الاتفاقية سارية من تاريخ التسجيل كصاحب حساب OneForma وتظل معمولًا بها حتى يُنهى الاتفاق باتفاق متبادل بينك وبين CENTIFIC أو من قِبل أي من الطرفين وفقًا للقسم 2.2.",
    p14: "2.2. الإنهاء. على الرغم من أي بند معاكس في هذه الاتفاقية، يحق لـ CENTIFIC إنهاء تسجيلك في OneForma في أي وقت، لأي سبب أو دون سبب، بإشعار كتابي مدته 30 يومًا. بالإضافة إلى أي علاجات قد تنص عليها هذه الاتفاقية، يجوز لـ CENTIFIC أيضًا إنهاء هذه الاتفاقية فورًا بإشعار لك إذا:",
    p15: "قبل توقيع هذه الاتفاقية أو عنده، لم توفر الشركة المعلومات أو المستندات ذات الصلة التي طلبتها CENTIFIC بشكل معقول، أو وفدت CENTIFIC بمعلومات أو مستندات كاذبة أو مضللة.",
    p16: "المشاركة في أي نشاط احتيالي، بما في ذلك على سبيل المثال لا الحصر:",
    p17: "تزوير بطاقة حضورك؛ التسعير المفرط؛ إدلاء أي تصريحات مضللة أو احتيالية ضد CENTIFIC أو مالك المشروع باستخدام آلات آلية لأداء الخدمات دون موافقة مالك المشروع مسبقًا؛",
    p18: "خرق جوهري لهذه الاتفاقية واتفاقية السرية، وكان هذا الخرق غير قابل للإصلاح، أو حتى لو كان قابلًا للإصلاح، فلم يُعالج خلال 7 أيام من إصدار إشعار بهذا الخرق؛ أو خرق أي تصريح أو ضمان قدمته بموجب هذه الاتفاقية أو وثيقة SOW المقابلة.",
    p19: "يجوز لك إنهاء هذه الاتفاقية بحذف حسابك من OneForma. في هذه الحالة، يجب أن تقدم لـ CENTIFIC تصريحًا مكتوبًا يذكر المبلغ الإجمالي الذي تدين به لك CENTIFIC في تاريخ الإنهاء. ثم ستدفع CENTIFIC ذلك المبلغ وفقًا للشروط والإجراءات المنصوص عليها في القسم 3 من هذه الشروط.",
    p20: "تفهم وتقر بأن إغلاق أي مشروع أو إنهاء أي SOW لن يؤدي تلقائيًا إلى إنهاء هذه الاتفاقية. وتم إنهاء وصولك إلى OneForma.",
    h_consequences: "2.3. عواقب الإنهاء",
    p21: "عند انتهاء هذه الاتفاقية أو إنهائها لأي سبب، أو في أي وقت آخر، بناءً على طلب كتابي من CENTIFIC أو مالك المشروع، يجب عليك، خلال ثلاثة أيام من ذلك الانتهاء أو الإنهاء، تسليم جميع المخرجات (المكتملة وغير المكتملة) وجميع المواد والمعدات والممتلكات الأخرى المقدمة لك من قِبل CENTIFIC أو مالك المشروع لاستخدامك إلى CENTIFIC و/أو مالك المشروع؛",
    p22: "تسليم جميع المستندات الملموسة وغيرها من الوسائط، بما في ذلك أي نسخ، التي تحتوي على معلومات سرية أو تعكسها أو تستند إليها إلى CENTIFIC أو مالك المشروع؛",
    p23: "يجب عليك حذف جميع المعلومات السرية نهائيًا من جهاز الكمبيوتر ونظام الصور لديك؛ وتقديم تأكيد كتابي إلى CENTIFIC ومالك المشروع بأنك استوفيت متطلبات هذا القسم. ما لم ينص القانون على غير ذلك، إذا تم إغلاق حسابك، فلن يكون لديك بعد ذلك وصول إلى أي معلومات أو مواد تخزنها على OneForma، وقد يُحذف أي محتوى مخزن في حسابك، وتنفي CENTIFIC مسؤوليتها عن ذلك صراحةً. يجوز لـ CENTIFIC الاحتفاظ ببعض معلومات حسابك أو كلها إذا سمح بذلك أو يطلبه القانون وسياسات الخصوصية.",
    h_payment: "3. الدفع",
    h_payment_method: "3.1 طريقة الدفع",
    p24: "يُجرى الدفع عبر Payoneer افتراضيًا. بتوقيعك عقدًا مع Payoneer أو تقديم معلومات دفع إلى Payoneer من خلال OneForma، تقرّ وتوافق على ما يلي: (أ) يخضع حسابك مع Payoneer وأي خدمات إدارة أموال ذات صلة لشروط وأحكام Payoneer وحدها؛ (ب) لا تتحمل CENTIFIC مسؤوليتك بشأن خدمات إدارة الأموال المقدمة من Payoneer، ولا تقدم CENTIFIC أي تصريحات أو ضمانات بشأن تلك الخدمات؛ (ج) لن تتحمل CENTIFIC المسؤولية، مباشرة أو غير مباشرة، عن أي ضرر أو خسارة فعلية أو مزعومة تنشأ عن استخدام خدمات إدارة الأموال المقدمة من Payoneer أو الاعتماد عليها؛ و(د) تتخلى بشكل لا رجعة فيه عن أي مطالبات ضد CENTIFIC وشركات التابعة لها المتعلقة بتلك الخدمات. إذا كنت تفضل طرق دفع أخرى، يرجى المراسلة على omegaguttakdl53@gmail.com",
    p25: "تقر وتوافق أيضًا على أن CENTIFIC لن تكون مسؤولة عن أي إخفاقات دفع ناتجة عن القانون المعمول به أو أي قيود تفرضها مؤسستك المالية، أو عن أي قيد دائن أو مدين تقوم به مؤسسة مالية يتعلق ب: حساب Payoneer الخاص بك أو أي طريقة دفع أخرى اتفقت عليها مع CENTIFIC. ستبذل CENTIFIC جهودًا معقولة تجاريًا للعمل معك لحل تلك المعاملات بطريقة تتوافق مع هذه الاتفاقية وأي قانون معمول به.",
    h_currency: "3.2. العملة وإجراءات الدفع",
    p26: "بحسب مالك المشروع والخدمات التي تختار أدائها، يجوز لـ CENTIFIC أن تقرر وفقًا لتقديرها الدفع بالدولار الأمريكي أو اليوان أو أي عملة أخرى.",
    h_prepay: "3.3. أنظمة الدفع المسبق",
    p27: "نتعامل مع تجار الفنادق، وعمل الحجز الحالي الخاص بك يتم على أساس الدفع المسبق. بما أن OneForma توفر منصة بدوام جزئي لجميع الأعضاء، تحتاج إلى توفير الأموال مقدمًا قبل الشروع في مهام الدفع المسبق. بعد اكتمال كل طلب، سيعيد النظام تلقائيًا المبلغ المكتسب وعمولتك. لذلك تحتاج إلى بدء عملك على أساس الدفع المسبق. بالتسجيل في OneForma أو استخدامها، توافق على الالتزام بهذه الاتفاقية. إذا كنت لا توافق على أي جزء أو على كامل هذه الاتفاقية، فلا يجوز لك التسجيل في OneForma. يرجى قراءة سياسات الخصوصية واللوائح ذات الصلة بعناية.",
    h_nofees: "3.5. لا توجد التزام بدفع الرسوم",
    p28: "تحمل جميع التكاليف وكل منها التي تتكبدها، بما في ذلك على سبيل المثال لا الحصر مصاريف السفر وغيرها من مصاريف العمل التي يتكبدها أنت أو موظفوك أو وكلاؤك أو مقاولوك أثناء أداء الخدمات بموجب هذه الاتفاقية. لن تكون CENTIFIC أو مالك المشروع مسؤولين عن أي مصاريف يتكبدها أنت أو موظفوك أو وكلاؤك أو مقاولوك أثناء أداء واجباتهم بموجب هذه الاتفاقية.",
    h_tax: "3.4. الضرائب",
    p29: "بالنسبة لجميع المستخدمين ودافعي الضرائب، تُدفع جميع ضرائبك مقدمًا إلى OneForma. مع أي دفع تجريه إلى OneForma، تقرّ وتوافق على أن OneForma قد خضعت أو دفعت أي دخل أو أروش أو ضمان اجتماعي أو ضرائب أخرى. لا تتحمل OneForma مسؤولية دفع أي أقساط تأمين (بما في ذلك أقساط تأمين البطالة أو الإعاقة) أو الحصول على تأمين تعويض العمال. نيابة عنك، ما لم ينص القانون المعمول به على غير ذلك، تتحمل التعويض عن CENTIFIC جميع تلك الضرائب أو المساهمات، بما في ذلك الغرامات والفوائد.",
    p30: "بالنسبة لدافعي الضرائب في أي ولاية قضائية أخرى، تتحمل مسؤولية أي ضرائب على المدفوعات الواردة من OneForma. إذا لم تدفع الضرائب وفقًا للقانون المعمول به، ستجمّد OneForma حسابك وتقدم إثباتًا بإخفائك من الضرائب للجهة الضريبية المختصة دون إشعار مسبق، متجهًا مباشرة إلى المحكمة في ولايتك القضائية الضريبية من خلال OneForma.",
  },

  app: {
    rejected_title: "تم رفض السحب",
  },
};

export default ar;
